import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { UpdateBookingInput } from "@/gql/graphql";
import { BookingUpdateDetailsForm } from "@/app/Bookings/Forms/BookingUpdateDetailsForm";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateBookingMutation } from "@/app/Bookings/GraphQL/bookingMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";

export function BookingEditReservationDetailsDialog({
  bookingId,
}: {
  bookingId: string;
}) {
  const booking = useBooking(bookingId);
  const { mutateAsync } = useGqlMutation(updateBookingMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Edit Reservation Details">
      <GenericForm<UpdateBookingInput>
        initialValues={{
          depart_at: booking.depart_at,
          deliver_at: booking.deliver_at,
          supplier_reference: booking.supplier_reference,
          customer_note: booking.customer_note,
          preferred_ferry_date: booking.preferred_ferry_date,
          departureOffice: {
            connect: booking.departureOffice.id,
          },
          distance_allowed: booking.distance_allowed,

          deliveryOffice: {
            connect: booking.deliveryOffice.id,
          },
          vehicle: {
            connect: booking.vehicle.id,
          },
          supplierInsuranceOption: {
            connect: booking.supplierInsuranceOption.id,
          },
          inclusions: {
            upsert: booking.inclusions.map((inclusion) => ({
              id: inclusion.id,
              type: inclusion.type,
              value: inclusion.value,
              description: inclusion.description,
              has_free_tank: inclusion.has_free_tank,
            })),
            delete: [],
          },
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: booking.id,
            input: values,
          });

          await close();
        }}
      >
        <BookingUpdateDetailsForm
          currency={booking.currency}
          measurement={booking.measurement}
          supplierId={booking.supplier.id}
          showFerryDate={
            !!booking.relocation.is_ferry_required ||
            !!booking.preferred_ferry_date
          }
        />

        <DialogSubmitButton text="Update reservation details" />
      </GenericForm>
    </BaseDialog>
  );
}
